import api from '@/lib/api';

import { auth } from '@/lib/firebase';

const GET_RECORDING_TIME = 'GET_RECORDING_TIME';
const GET_LAST_EXIT_TIME = 'GET_LAST_EXIT_TIME';
const GET_SELECTED_AUDIO = 'GET_SELECTED_AUDIO';

const SET_RECORDING_TIME = 'SET_RECORDING_TIME';
const SET_LAST_EXIT_TIME = 'SET_LAST_EXIT_TIME';
const SET_SELECTED_AUDIO = 'SET_SELECTED_AUDIO';

const getDefaultState = () => {
  return {
    recordingTime: 0,
    lastExitTime: null,
    selectedAudio: null,
  }
};

export const state = getDefaultState();

export const mutations = {
  [SET_RECORDING_TIME](state, recordingTime) {
    state.recordingTime = recordingTime;
  },
  [SET_LAST_EXIT_TIME](state, time) {
    state.lastExitTime = time;
  },
  [SET_SELECTED_AUDIO](state, selectedAudio) {
    state.selectedAudio = selectedAudio;
  }
}

export const getters = {
  [GET_RECORDING_TIME](state) {
    return state.recordingTime;
  },
  [GET_LAST_EXIT_TIME](state) {
    return state.lastExitTime;
  },
  [GET_SELECTED_AUDIO](state) {
    return state.selectedAudio;
  }
}

export const actions = {
  async addAudio(_, params) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.post('/audio',
        params,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getAudio(_, { id }) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(`/audio/${id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchTranscriptions(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get('/audio/transcriptions',
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` } 
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchWeeklyTranscriptions(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get('/audio/week/transcriptions',
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` } 
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getMonthlyStats(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get('/audio/monthly/stats',
        {
          params: payload,
          headers: { Authorization: `Bearer ${token}` }
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getMonthlyInsights(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get('/audio/monthly/insights',
        {
          params: payload,
          headers: { Authorization: `Bearer ${token}` }
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async deleteAudio(_, { id }) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.delete(`/audio/${id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}